module.exports = __webpack_public_path__ + "static/media/header.e9bb22be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header.png
// module id = 274
// module chunks = 0